import React from 'react';
import {useAuth} from "../../../helpers/AuthContext";
import Form from "../../Form";
import CouponForm from "./CouponForm";
import Modal from "../../Modal";
import EditCouponForm from "./EditCouponForm";

function EditCouponModal({
                             coupon,
                             onSuccess,
                             onError,
                             onClose
                         }) {
    return (
        <Modal
            isOpen={true}
            title={`Edit Coupon: ${coupon.code}`}
            onClose={onClose}
        >
            <EditCouponForm
                coupon={coupon}
                onSuccess={() => {
                    if (onSuccess) {
                        onSuccess();
                    }
                }}
                onError={(error) => {
                    if (onError) {
                        onError(error);
                    }
                }}
            />
        </Modal>
    );
}

export default EditCouponModal;